<div class="p-4">
  <p class="text-base font-semibold">
    {{ title }}
  </p>

  <p class="text-sm">
    {{ description }}
  </p>

  <div class="flex justify-end gap-x-3 mt-3">
    <button ctrStrokedButton (click)="clickNo()">
      {{ noText }}
    </button>

    <button ctrButton (click)="clickYes()">
      {{ yesText }}
    </button>
  </div>
</div>
